import axiosInstance, { createUrl } from ".";

export const bulkUploader = async ( formData: any) => {
  console.log("bulkUploader", formData);
  try {
    const result: any = await axiosInstance.post(
      createUrl("/api/v1/partner/preferences/csv"),
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    console.log('result',result);
    if (result.status === 200) {
      return result?.data;
    } else {
      return [];
    }
  } catch (err: any) {
    const errorMessage = { message: "" };
    if (
      err.response.data.statusCode !== 500 &&
      err.response.data.statusCode !== 404
    ) {
      errorMessage.message = err?.response?.data?.message;
    } else {
      errorMessage.message = "";
    }
    throw errorMessage;
  } finally {
  }
};

export const bulkUploaderLogs = async (params:any) => {
    try {
        const result: any = await axiosInstance.get(createUrl("/api/v1/bulk-uploader/logs"), {
          params,
        });
        //   console.
        if (result.status === 200) {
          return result?.data || [];
        } else {
          return [];
        }
      } catch (err: any) {
        console.log(">>>>>>>Error", err?.response?.data?.message[0]);
      } finally {
      }
      return [];
};
